// Gestion de l'identifiant unique du téléphone (identification persistante)
export const getPhoneId = () => {
  let phoneId = localStorage.getItem('phone_id');
  
  if (!phoneId) {
    // Générer un identifiant unique si aucun n'existe
    phoneId = generatePhoneId();
    localStorage.setItem('phone_id', phoneId);
  }
  
  return phoneId;
};

const generatePhoneId = () => {
  // Générer un identifiant unique basé sur plusieurs facteurs
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  const userAgent = navigator.userAgent.substring(0, 10);
  
  // Combiner pour créer un identifiant unique
  const combined = `${timestamp}-${random}-${userAgent}`;
  
  // Créer un hash simple
  let hash = 0;
  for (let i = 0; i < combined.length; i++) {
    const char = combined.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convertir en 32 bits
  }
  
  return `PHONE-${Math.abs(hash).toString(36)}-${random}`;
};

